<article class="w-full background flex flex-column justify-content-center align-items-center relative"
  (click)="toggleInformation($event)">
  <section *ngIf="sensorList.length > 0 && sensorList.length <= 3" class="hidden lg:flex lg:flex-column">
    <section class="w-fit -mb-6 relative z-1 mx-auto">
      <section class="w-full flex justify-content-between align-items-center gap-8 -mb-1">
        <section class="w-16rem flex justify-content-center" *ngFor="let item of sensorList">
          <img src="assets/images/sensors/sot.png" alt="Soterrado" class="h-15rem">
        </section>
      </section>

      <div class="absolute w-full h-1rem ci-bg--black border-round-top-lg -mt-7"></div>
    </section>

    <section
      class="z-1 w-fit bg-white-alpha-20 flex justify-content-center align-items-center gap-8 px-6 pt-7 pb-5 border-round-xl">
      <section *ngFor="let item of sensorList">
        <section>
          <div class="h-10rem w-16rem bg-white-alpha-50 flex flex-column justify-content-end relative overflow-hidden"
            style="border-right: 7px solid #e05306; border-left: 7px solid #e05306;">

            <section *ngIf="item.payload">
              <div
                class="ci-bg--fill h-{{getPercetage(item.payload.Distance)[0]}}rem ci-bg--{{getPercetage(item.payload.Distance)[2]}}">
              </div>

              <div class="w-full py-3 text-center absolute text-6xl bottom-0">
                <div class="w-fit bg-white mx-auto p-1 px-2 border-round-xl shadow-2 flex align-items-end gap-1">
                  {{getPercetage(item.payload.Distance)[1]}} <div class="text-4xl">%</div>
                </div>
              </div>
            </section>

            <section class="w-full text-center font-normal pt-3 text-2xl ci-txt--white absolute top-0 opacity-70">
              {{item.type}}
            </section>
          </div>

          <div class="w-full">
            <div class="h-1rem ci-bg--yellow border-round-bottom-sm"></div>

            <div class="w-full flex justify-content-between -mt-2 px-5">
              <div class="w-2rem h-2rem ci-bg--black opacity-80 border-circle"></div>

              <div class="w-2rem h-2rem ci-bg--black opacity-80 border-circle"></div>
            </div>
          </div>
        </section>
      </section>
    </section>
  </section>

  <section *ngIf="sensorList.length > 0 && sensorList.length <= 3" class="w-full lg:hidden">
    <swiper-container pagination="true" pagination-clickable="true" pagination-dynamic-bullets="true"
      autoplay-disable-on-interaction="true" slides-per-view="1">
      <swiper-slide *ngFor="let device of sensorList" class="w-full">
        <section
          class="w-10rem h-auto ci-txt--white mx-auto mb-6 flex flex-column justify-content-center align-items-center gap-3">
          <section class="w-fit relative z-1 mx-auto -mb-4">
            <section class="w-full flex justify-content-between align-items-center -mb-1 relative">
              <section class="w-10rem flex justify-content-center">
                <img src="assets/images/sensors/sot.png" alt="Soterrado" class="h-15rem">
              </section>

              <section class="w-full absolute right-0 left-0">
                <p class="w-fit text-lg text-center mx-auto ci-bg--cherry border-round-xl p-1 px-2">
                  {{device.type}}
                </p>
              </section>
            </section>

            <div class="absolute w-full h-1rem ci-bg--black border-round-top-lg -mt-7"></div>
          </section>

          <div>
            <div
              class="w-10rem h-10rem w-full bg-white-alpha-50 flex flex-column justify-content-end relative overflow-hidden"
              style="border-right: 7px solid #E36C2C; border-left: 7px solid #E36C2C;">
              <section *ngIf="device.payload" class="bg-white-alpha-50">
                <div
                  class="ci-bg--fill h-{{getPercetage(device.payload.Distance)[0]}}rem ci-bg--{{getPercetage(device.payload.Distance)[2]}}">
                </div>

                <div class="w-full py-3 text-center absolute text-6xl bottom-0 ci-txt--black">
                  <div class="w-fit bg-white mx-auto p-1 px-2 border-round-xl shadow-2 flex align-items-end gap-1">
                    {{getPercetage(device.payload.Distance)[1]}} <div class="text-4xl">%</div>
                  </div>
                </div>
              </section>
            </div>

            <div class="w-full">
              <div class="h-1rem ci-bg--yellow border-round-bottom-sm"></div>

              <div class="w-full flex justify-content-between -mt-2 px-3">
                <div class="w-2rem h-2rem ci-bg--black opacity-90 border-circle"></div>

                <div class="w-2rem h-2rem ci-bg--black opacity-90 border-circle"></div>
              </div>
            </div>
          </div>
        </section>
      </swiper-slide>
    </swiper-container>
  </section>

  <section *ngIf="location" class="w-full md:text-xl text-center mt-4">
    <p class="ci-txt--white">
      <i class="bi bi-geo-alt-fill"></i>

      {{ location.address }}
    </p>
  </section>

  <section *ngIf="sensorList.length > 0" class="hidden lg:block absolute bottom-0 left-0 z-1 p-1">
    <img
      src="https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/logos%2Fsomosinno.png?alt=media&token=9a70e2fa-df39-4e67-adb5-594d2b439c00"
      alt="GAMC Logo" class="h-3rem w-auto">
  </section>

  <section *ngIf="sensorList.length > 0" class="absolute top-0 right-0 m-3 z-1">
    <section class="w-full flex justify-content-end">
      <i class="pi pi-info-circle ci-txt--white text-2xl cursor-pointer">
      </i>
    </section>

    <section *ngIf="showInfo"
      class="fadein animation-duration-500 flex flex-column align-items-start gap-3 p-3 px-5 shadow-3 bg-white-alpha-90 border-round-xl mt-2">
      <h3 class="ci-txt--black text-lg font-bold">Nivel de residuos</h3>

      <section class="w-8 flex align-items-center justify-content-between ci-txt--black-lighten">
        Alto

        <div class="ci-bg--red h-1rem w-1rem border-round-sm shadow-1"></div>
      </section>

      <section class="w-8 flex align-items-center justify-content-between ci-txt--black-lighten">
        Medio

        <div class="ci-bg--yellow h-1rem w-1rem border-round-sm shadow-1"></div>
      </section>

      <section class="w-8 flex align-items-center justify-content-between ci-txt--black-lighten">
        Bajo

        <div class="ci-bg--green h-1rem w-1rem border-round-sm shadow-1"></div>
      </section>
    </section>
  </section>

  <section *ngIf="sensorList.length === 0">
    <p class="text-center ci-txt--white text-xl md:text-2xl">
      No se encontraron sensores disponibles.
    </p>
  </section>

  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</article>

<style>
  @keyframes move {
    100% {
      transform: translate3d(0, 0, 1px) rotate(360deg);
    }
  }

  .ci-bg--fill {
    transition: height 1s ease;
  }

  .background {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background: #3E1E68;
    overflow: hidden;
  }

  .background span {
    width: 29vmin;
    height: 29vmin;
    border-radius: 29vmin;
    backface-visibility: hidden;
    position: absolute;
    animation: move;
    animation-duration: 45;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }


  .background span:nth-child(0) {
    color: #583C87;
    top: 99%;
    left: 83%;
    animation-duration: 55s;
    animation-delay: -8s;
    transform-origin: 11vw 10vh;
    box-shadow: -58vmin 0 8.034572936390436vmin currentColor;
  }

  .background span:nth-child(1) {
    color: #583C87;
    top: 15%;
    left: 71%;
    animation-duration: 33s;
    animation-delay: -23s;
    transform-origin: -23vw -24vh;
    box-shadow: 58vmin 0 7.598451895678432vmin currentColor;
  }

  .background span:nth-child(2) {
    color: #583C87;
    top: 27%;
    left: 4%;
    animation-duration: 38s;
    animation-delay: -18s;
    transform-origin: -1vw -9vh;
    box-shadow: 58vmin 0 7.4967193625667665vmin currentColor;
  }

  .background span:nth-child(3) {
    color: #583C87;
    top: 38%;
    left: 68%;
    animation-duration: 44s;
    animation-delay: -33s;
    transform-origin: 11vw 5vh;
    box-shadow: 58vmin 0 8.044109931129903vmin currentColor;
  }

  .background span:nth-child(4) {
    color: #583C87;
    top: 81%;
    left: 95%;
    animation-duration: 50s;
    animation-delay: -4s;
    transform-origin: -4vw -20vh;
    box-shadow: -58vmin 0 7.467940959800993vmin currentColor;
  }

  .background span:nth-child(5) {
    color: #583C87;
    top: 48%;
    left: 56%;
    animation-duration: 12s;
    animation-delay: -6s;
    transform-origin: 22vw -10vh;
    box-shadow: 58vmin 0 7.709377982775084vmin currentColor;
  }

  .background span:nth-child(6) {
    color: #583C87;
    top: 92%;
    left: 50%;
    animation-duration: 48s;
    animation-delay: -24s;
    transform-origin: -23vw -19vh;
    box-shadow: 58vmin 0 7.378340985981666vmin currentColor;
  }

  .background span:nth-child(7) {
    color: #583C87;
    top: 34%;
    left: 65%;
    animation-duration: 36s;
    animation-delay: -15s;
    transform-origin: -9vw 4vh;
    box-shadow: 58vmin 0 7.971365507965336vmin currentColor;
  }

  .background span:nth-child(8) {
    color: #583C87;
    top: 9%;
    left: 78%;
    animation-duration: 22s;
    animation-delay: -8s;
    transform-origin: -2vw -4vh;
    box-shadow: -58vmin 0 7.960632762435518vmin currentColor;
  }
</style>